import React from 'react';
import { CircularProgress, Box } from '@mui/material';
import { buttonSx } from './buttonSx';
import { ButtonVariant } from './Button';

type ButtonContentProps = {
  variant: ButtonVariant;
  loading: boolean;
  loadingType: 'spinner' | 'bar';
  isBarLoading: boolean;
  children?: React.ReactNode;
};

export const ButtonContent: React.FC<ButtonContentProps> = ({
  variant,
  loading,
  loadingType,
  isBarLoading,
  children
}) => {
  if (variant === 'tertiary') {
    return (
      <>
        {children}
        {loading && (
          <CircularProgress size={16} sx={buttonSx.loadingSpinnerInline} />
        )}
      </>
    );
  }

  if (loadingType === 'bar') {
    return (
      <>
        <Box sx={buttonSx.loadingContent(isBarLoading)}>{children}</Box>
        {isBarLoading && (
          <Box sx={buttonSx.barLoadingTrack}>
            <Box sx={buttonSx.barLoadingSlider} />
          </Box>
        )}
      </>
    );
  }

  return (
    <Box sx={buttonSx.loadingContainer}>
      {loading && <CircularProgress size={16} sx={buttonSx.loadingSpinner} />}
      <Box sx={buttonSx.loadingContent(loading)}>{children}</Box>
    </Box>
  );
};
